(function(){
    'use strict';
    angular.module('Directives').directive('bbaList', bbaList);

    bbaList.$inject = [];

    function bbaList() {
        return {
            restrict: 'E',
            templateUrl: '/templates/directives/bbaList.html',
            scope: {
                listData: '=',
            },
            link: bbaListLink
        }

        function bbaListLink($scope, $element, $attrs){
        }
    }
})()


// WEBPACK FOOTER //
// ./js/directives/bbaList.js